<ng-container [ngSwitch]="paymentStatus">
  <ng-container *ngSwitchCase="'paying'">
    <ab-payment-screen [rendering]="rendering" (setPaymentStatus)="setPaymentStatus($event)"
      (setCancelReturnUrl)="setCancelReturnUrl($event)"
      (setMerchantInfo)="setMerchantInfo($event)"></ab-payment-screen>
  </ng-container>
  <ng-container *ngSwitchCase="'cancelled'">
    <ab-payment-cancelled [returnUrl]="returnUrl"></ab-payment-cancelled>
  </ng-container>
  <ng-container *ngSwitchCase="'expired'">
    <ab-payment-expired></ab-payment-expired>
  </ng-container>
  <ng-container *ngSwitchCase="'connection'">
    <ab-connection-error (resetPayment)="resetPayment()"></ab-connection-error>
  </ng-container>
  <ng-container *ngSwitchCase="'invalid'">
    <ab-payment-invalid (resetPayment)="resetPayment()"></ab-payment-invalid>
  </ng-container>
  <ng-container *ngSwitchCase="'complete'">
    <ab-payment-complete [merchantInfo]="merchantInfo"></ab-payment-complete>
  </ng-container>
  <ng-container *ngSwitchCase="'pending'">
    <ab-payment-pending [merchantInfo]="merchantInfo"></ab-payment-pending>
  </ng-container>
</ng-container>